import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import './App.css';

// Reusable Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Preloader from './components/Preloader';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';

// Interactive Modals
import ProductEnquiryModal from './components/ProductEnquiryModal';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Products from './pages/Products';
import Projects from './pages/Projects';
import Blogs from './pages/Blogs';
import ApplyJob from './pages/ApplyJob';
import Contact from './pages/Contact';

// Admin Components
import AdminSignIn from './admin/AdminSignIn';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import ManageServices from './admin/ManageServices';
import ManageGrowthStats from './admin/ManageGrowthStats';
import ManageProducts from './admin/ManageProducts';
import ManageBlogs from './admin/ManageBlogs';
import ManageJobs from './admin/ManageJobs';
import Consultations from './admin/Consultations';
import ManageProjects from './admin/ManageProjects';
import ProductEnquiries from './admin/ProductEnquiries';

function App() {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('');

  const triggerProductEnquiry = (productName) => {
    setSelectedProduct(productName);
    setEnquiryOpen(true);
  };

  return (
    <BrowserRouter>
      {/* Premium clinical pulse loader */}
      <Preloader />
      
      {/* Global Scroll restoration & Back-to-Top trigger */}
      <ScrollToTop />
      
      <div className="flex flex-col min-h-screen bg-brand-light font-sans text-brand-navy selection:bg-brand-blue selection:text-white antialiased">
        
        <Routes>
          {/* Public Website Layout */}
          <Route element={
            <>
              <Navbar />
              <main className="flex-grow">
                <Outlet />
              </main>
              <Footer />
              <WhatsAppButton />
              <ProductEnquiryModal 
                isOpen={enquiryOpen} 
                onClose={() => setEnquiryOpen(false)} 
                productName={selectedProduct}
              />
            </>
          }>
            <Route path="/" element={<Home onOpenEnquiry={triggerProductEnquiry} />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products onOpenEnquiry={triggerProductEnquiry} />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/careers" element={<Navigate to="/contact?tab=careers" replace />} />
            <Route path="/apply-job" element={<ApplyJob />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          {/* Admin Panel Panel & Authentication Tunnel */}
          <Route path="/admin/login" element={<AdminSignIn />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="services" element={<ManageServices />} />
            <Route path="stats" element={<ManageGrowthStats />} />
            <Route path="products" element={<ManageProducts />} />
            <Route path="projects" element={<ManageProjects />} />
            <Route path="blogs" element={<ManageBlogs />} />
            <Route path="jobs" element={<ManageJobs />} />
            <Route path="enquiries" element={<ProductEnquiries />} />
            <Route path="consultations" element={<Consultations />} />
          </Route>
        </Routes>
        
      </div>
    </BrowserRouter>
  );
}

export default App;

